import { useState, useEffect, useCallback } from "react";

const useApi = (apiFunction, executeImmediately = true) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const callApi = useCallback(
    async (params = null, callback) => {
      setLoading(true);
      try {
        const response = await apiFunction(params);
        setData(response.data);
        setError(null);
        if (callback) callback(response.data, null);
      } catch (err) {
        const errorMessage =
          err.response?.data?.message ||
          err.response?.data?.error ||
          "Something went wrong!";
        if (callback) callback(null, errorMessage, err?.status);
        setError(err);
      } finally {
        setLoading(false);
      }
    },
    [apiFunction]
  );

  useEffect(() => {
    if (executeImmediately) {
      callApi();
    }
  }, [executeImmediately, callApi]);

  return { data, error, loading, callApi };
};

export default useApi;
